var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":require('@/assets/img/' + _vm.color + 'logo.svg'),"alt":"Repay"},on:{"click":function($event){return _vm.$router.go('/events')}}})}
var staticRenderFns = []

export { render, staticRenderFns }